export default {"src":"/_next/static/media/rafting.3b450e84.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};